// extracted by mini-css-extract-plugin
module.exports = {"inlineTestimonial":"inlineTestimonial-module--inlineTestimonial--1A3Ff","inlineTestimonialContent":"inlineTestimonial-module--inlineTestimonialContent--1k7wM"};